import moment from 'moment';

const httpOptions = { withCredentials: true };

class InvoiceCreateOtherController {

  constructor(toastr, $http, $rootScope, $state) {
    "ngInject";

    this.toastr = toastr;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$state = $state;

    this.customers = [];
    this.contracts = [];
    this.projects = [];
    this.lineItems = [];

    this.invoice = {
      customer: 'all',
      contract: 'all',
      project: 'all',
      invoiceDate: moment().toDate(),
      invoicePeriodStart: null,
      invoicePeriodEnd: null,
      description: ''
    };

    this.calculateInvoicePeriod();
    this.addLineItem();

    $http.get(this.formAdminApi('customers/names'), httpOptions).then((success) => {
      this.customers = success.data;
    });

    $http.get(this.formAdminApi('invoices/invnumber/next'), httpOptions).then((success) => {
      this.invoice.invoiceNumber = success.data;
    });

    $http.get(this.formAdminApi('companies/mycompany'), httpOptions).then((success) => {
      this.invoice.company = success.data;
    });
  }

  formApi(endpoint) {
    return `${this.$rootScope.apiHost}/api/${endpoint}`;
  }

  formAdminApi(endpoint) {
    return this.formApi(`admin/${endpoint}`);
  }

  calculateInvoicePeriod() {
    const start = moment().subtract(1, 'month').startOf('month');
    const end = moment().subtract(1, 'month').endOf('month');
    this.invoice.invoicePeriodStart = start.toDate();
    this.invoice.invoicePeriodEnd = end.toDate();
  }

  selectCustomer() {
    if (!this.invoice.customer || this.invoice.customer === 'all') {
      this.contracts = [];
      this.projects = [];
      return;
    }

    this.$http.get(
      this.formAdminApi(`contracts/bycustomer?customer=${this.invoice.customer.id}`),
      httpOptions
    ).then((success) => {
      this.contracts = success.data;
      this.projects = [];
      this.invoice.contract = 'all';
      this.invoice.project = 'all';
    });
  }

  selectContract() {
    if (!this.invoice.contract || this.invoice.contract === 'all') {
      this.projects = [];
      return;
    }

    this.$http.get(
      this.formAdminApi(`projects/bycontract?contract=${this.invoice.contract.id}`),
      httpOptions
    ).then((success) => {
      this.projects = success.data;
      this.invoice.project = 'all';
    });
  }

  addLineItem() {
    this.lineItems.push({
      lineNumber: this.lineItems.length + 1,
      description: '',
      quantity: 1,
      rate: 0
    });
  }

  removeLineItem(index) {
    this.lineItems.splice(index, 1);
    this.lineItems.forEach((item, idx) => {
      item.lineNumber = idx + 1;
    });
  }

  getLineItemTotal(lineItem) {
    const quantity = parseFloat(lineItem.quantity) || 0;
    const rate = parseFloat(lineItem.rate) || 0;
    return quantity * rate;
  }

  getInvoiceTotal() {
    return this.lineItems.reduce((total, item) => total + this.getLineItemTotal(item), 0);
  }

  canCreateInvoice() {
    if (!this.invoice.customer || this.invoice.customer === 'all') {
      return false;
    }

    return this.lineItems.length > 0
      && this.lineItems.every((item) => item.description && item.description.trim() !== '')
      && this.getInvoiceTotal() > 0;
  }

  createInvoice() {
    if (!this.canCreateInvoice()) {
      this.toastr.warning('Complete all required fields and add at least one line item.', 'Incomplete');
      return;
    }

    this.toastr.info('Other invoice creation will be available once the backend API is connected.', 'Coming Soon');
  }

  goBack() {
    this.$state.go('admin.invoice-create-wizard');
  }
}

export default InvoiceCreateOtherController;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create-other/invoice-create-other.controller.js